export const updateTimestamp = () => {
    return {
        type: "UPDATE_TIMESTAMP"
    };
};